<template>
<main class="signup-form">
    <div class="container">
        <div class="row justify-content-center m-0">
            <div class="col-md-4">
                <div class="card">
                <div class="card-header normal">Reset Password</div>
                <div class="card-body">

                    <div class="alert alert-danger text-center" role="alert" v-if="error_message">
                        {{error_message}}
                    </div>
                    
                    <div class="alert alert-success mb-0 text-center" role="alert" v-if="success_message">
                        {{success_message}}
                    </div>

                <div v-if="!submitted">
                <p class="card-text mb-2">Please enter your email address</p>
                
                    <div class="form-group">      
                        <input type="text" class="form-control" v-model="email" />
                    </div>

                    <div v-if="loading" class="text-center"><i class="fas fa-spinner fa-spin fa-2x"></i></div>
                    <button v-else class="btn btn-danger btn-block" @click="submitForm">Submit</button>

                    </div>

            </div>
                </div>
                <p class="mt-3 text-center">
          <a href="/login">Back to login</a>
        </p>
            </div>
        </div>
    </div>
</main>
</template>

<script>

export default {

  data() {
    return {
      email: '',
      error_message: '',
      success_message: '',
      loading: false,
      submitted: false,
    };
  },

  created() {
    
  },

  methods: {

      submitForm() {

          this.error_message = '';

          if (this.email=='') { this.sweetfire('Please enter your email address')}

          else {

          this.loading = true;

          axios
          .post("/password-post", {email: this.email})
          .then((response) => {
            
            if (response.data.success) {
                this.success_message = response.data.message;
                this.submitted = true;
            }

            else this.error_message = response.data.message;
            
            this.loading = false;

          })
          .catch(function (err) {
            console.log(err);
            this.loading = false;
          });

          }
      
      },


    sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },

  },
};
</script> 